import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import "./style/index.css";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import moment from "moment";
Vue.prototype.$moment = moment;
// 配置项
Vue.use(VueLazyload, {
  preLoad: 1.3,
  // error: 'dist/error.png',
  loading: require('./assets/loading.gif'),
  attempt: 1
})
import VueLazyload from 'vue-lazyload'


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
